var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveB2Bwellpoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_6830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.42621 17.854L6.14619 21.5738C9.04433 24.472 13.4514 23.3253 18.388 18.3887C23.3248 13.4521 24.4714 9.04498 21.5733 6.14686L17.8533 2.42688C20.7514 5.32502 19.6048 9.73207 14.6681 14.6687C9.73141 19.6053 5.32435 20.752 2.42621 17.854Z",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6652 14.6669L18.3867 18.3885",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57172 18.5391L13.2849 22.2522",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5223 9.55664L22.2381 13.2723",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.42644 17.8535C5.32456 20.7516 9.73163 19.6049 14.6683 14.6683C19.6049 9.73169 20.7516 5.32462 17.8534 2.4265C14.9553 -0.471635 10.5483 0.675034 5.61162 5.61168C0.674973 10.5483 -0.471696 14.9554 2.42644 17.8535Z",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_6830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveB2Bwellpoints);
export default __webpack_public_path__ + "static/media/active-b2bwellpoints.2c2749205e68645a35a977466dcddcb8.svg";
export { ForwardRef as ReactComponent };